import instance from '../utils/axios';

class FormsService {

    async getList(type,deptId,value) {
       if (type === 0){
           return await instance.post('/crm/user/getStaffByIds?staffIds='+localStorage.getItem("staffIds")+"&value="+value);
       }else if (type === 1) {
           return await instance.post('/crm/user/getStaffByUserId?value='+value);
       }else {
           return await instance.post('/crm/user/getByDept?departmentId='+deptId+"&value="+value);
       }
    }

}

export default new FormsService();